import React from "react";
import "./SlotItem.css";

const SlotItem = ({
  startTime,
  endTime,
  format = "12h",
  backgroundColor = "#FFFFFF",
  textColor = "var(--blue-b0)",
  borderColor = "var(--blue-b0)",
  selected = false,
  label,
  notificationCount,
  onClick,
}) => {
  const isSelectedVariant =
    selected ||
    backgroundColor === "var(--blue-b0)" ||
    textColor === "var(--surface-white)" ||
    borderColor === "var(--surface-white)";

  const formatTime = (time) => {
    if (!time) return "";

    const date = new Date(time + "Z");

    if (isNaN(date.getTime())) return "";

    return date.toLocaleTimeString("en-IN", {
      hour: format === "24h" ? "2-digit" : "numeric",
      minute: "2-digit",
      hour12: format !== "24h",
    });
  };

  const renderTime = () => {
    if (label) return label;
    return `${formatTime(startTime)} - ${formatTime(endTime)}`;
  };

  return (
    <div
      onClick={onClick}
      className={`slotItem ${isSelectedVariant ? "slotItemSelected" : "slotItemDefault"}`}
    >
      {renderTime()}
      {notificationCount > 0 && (
        <span className="slotItemNotificationBadge">{notificationCount}</span>
      )}
    </div>
  );
};

export default SlotItem;
